export type AccountInfo = {
  currentAccountName: string;
  accounts: AccountInfoByType[];
  currentMarketplaceId: string;
  currentEntityId: string;
  currentAccountType: string;
}

export type AccountInfoByType = {
  label: string;
  accountType: AccountType;
  accounts: DetailAccountInfo[];
}

// @ts-ignore
export const AccountTypes = window.AACChrome.InternalAPI.AdvertisingAccountType as const;
export type AccountType = typeof AccountTypes[keyof typeof AccountTypes];

export type DetailAccountInfo = {
  entityId?: string;
  accountType?: AccountType;
  label: string;
  url: string;
  marketplaceName?: string;
  regionId: Region;
  nestedAccounts: DetailAccountInfo[];
}

export enum Region {
  NA = 'NA',
  EU = 'EU',
  APAC = 'APAC',
  MENA = 'MENA',
  SA = 'SA',
}

export type CountryLinksWithRegion = {
  region: Region;
  countryLinks: CountryLink[];
}

export type CountryLink = {
  country: string;
  url: string;
};

export type RegionLink = {
  region: Region;
  url: string;
};
export enum WeblabedFeatures {
  TEST_WEBLAB_BTSW = 'TEST_WEBLAB_BTSW',
}

export const multiCountryAccountType = [AccountTypes.MANAGER, AccountTypes.DSP_ENTITY];

// Will add these types inside AACChromeInternalAPI and import from there
export interface Feature {
  name: string;
  isEnabled: boolean;
  content?: any;
}

export interface InternalChromeConfig {
  featureLaunchInfo?: {
    features: Feature[];
  };
  entityId: string;
  marketplaceId: string;
  locale: string;
  deviceType: string;
  deviceEnv: string;
  mobileWebSupport: string;
  forceDesktopSite: boolean;
  applicationName: string;
  isInterstitialPage: boolean;
  isFromRodeo: boolean;
}
